import { forEach } from "lodash";
import { useEffect, useRef, useState } from "react";

const NaverMapComponent = props => {
  const { selected, reload } = props;
  const mapElement = useRef(null);
  const [mapCenter, setMapCenter] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(12);

  useEffect(() => {
    
    const loadMap = () => {
      if (!window.naver) return;
  
      // Calculate center from selected
      const latitudes = selected.map(item => item.com_lat);
      const longitudes = selected.map(item => item.com_lon);
      let centerLatitude = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
      let centerLongitude = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;
  
      // calculate zoom level based on the number of selected items
      
      // find the max and min latitude and longitude
      const maxLat = Math.max(...latitudes);
      const minLat = Math.min(...latitudes);
      const maxLon = Math.max(...longitudes);
      const minLon = Math.min(...longitudes);
      const latDiff = maxLat - minLat;
      const lonDiff = maxLon - minLon;
      const latZoom = Math.floor(Math.log2(360 / latDiff));
      const lonZoom = Math.floor(Math.log2(360 / lonDiff));
      const zoomLevel = Math.min(latZoom, lonZoom);
      
      if(isFinite(zoomLevel)) {
        setZoomLevel(zoomLevel);
      } else {
        setZoomLevel(12);
      }

      // Fallback to default center if no valid coordinates
      if (isNaN(centerLatitude) || isNaN(centerLongitude)) {
        centerLatitude = 37.5665; // Default latitude (Seoul)
        centerLongitude = 126.9780; // Default longitude (Seoul)
      }

      // Update mapCenter state
      setMapCenter(new window.naver.maps.LatLng(centerLatitude, centerLongitude));
    };

    if (!window.naver) {
      const script = document.createElement("script");
      script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=gitwswiggr`;
      script.async = true;
      script.onload = loadMap;
      document.body.appendChild(script);
    } else {
      loadMap();
    }
  }, [reload]);

  useEffect(() => {
    if (!mapCenter || !window.naver) return;

    // Initialize the map with the updated mapCenter
    const map = new window.naver.maps.Map(mapElement.current, {
      center: mapCenter,
      zoom: zoomLevel,
    });
  
    if (selected.length > 0) {
      forEach(selected, (item) => {
        const marker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(item.com_lat, item.com_lon),
          map: map,
        });

        const infoWindow = new window.naver.maps.InfoWindow({
            content:`<div style="padding: 5px 10px;">\
                    <h3>${item.com_name}</h3>\
                    <p>${item.com_zip} ${item.com_addr1} ${item.com_addr2}<br/>연락처: ${item.phone}<br/>담당자: ${item.com_charge}</p>\
                    </div>`,
            maxWidth: 300,
            backgroundColor: "#eee",
            borderWidth: 1,
            anchorSize: new naver.maps.Size(20, 20),
            anchorSkew: true,
            anchorColor: "#eee",
            pixelOffset: new naver.maps.Point(0, -20)
        });

        naver.maps.Event.addListener(marker, "click", function(e) {
          if (infoWindow.getMap()) {
            infoWindow.close();
          } else {
            infoWindow.open(map, marker.getPosition());
          }
        });

      });
    }
  }, [mapCenter]);

  return <div ref={mapElement} style={{ width: "100%", height: "500px" }} />;
};

export default NaverMapComponent;